import { Injectable } from "@angular/core";
import { unparse } from 'papaparse/papaparse.min.js';
import { saveAs } from 'file-saver';
import { CsvColumn } from '../models/csv-column-model';
import {IBANExportPipe} from '../../../../common/pipes/IBAN-export.pipe';
import { ColumnDefinitionFormatType } from '../../../../common/enums/column-definition-format-type';

@Injectable()
export class ExportCsvService {

    constructor(
      private readonly IBANExportPipe: IBANExportPipe
    ){}
    export(data: any[], columns: CsvColumn[]){

        const rows = data.map(row=> {
            const rowItem = {};
            columns.forEach(col =>{
              rowItem[col.Label] = col.MappingFunc ? col.MappingFunc(row) : this.formatData(row[col.FieldName], col.Type);
            })
            return rowItem;
          })

        var rowsInCSVFormat = unparse(rows);

        const blob = new Blob([rowsInCSVFormat], {
            type: 'text/csv;charset=utf-8;',
        });

        saveAs(blob, 'data.csv');
    }

    formatData(data: any, type: ColumnDefinitionFormatType){
      if (type == ColumnDefinitionFormatType.IBAN)
        return this.IBANExportPipe.transform(data);
      return data;
    }
}
